import { useState, useRef } from 'react';
import {
    Dialog,
    DialogContent,
    Typography,
    MenuItem,
    Box,
    IconButton,
    styled,
    Backdrop,
    Menu,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import StatusPill from '../../../Shared/Components/StatusPill';
import { COLORS } from '../../../utils/Application_Constants';
import { PROCESSED_TIMESHEET_STATUS_LABELS } from '../../constants';
import InvoiceReviewResolutionForm from './InvoiceReviewResolutionForm';
import UpdateStatusReasonForm from './UpdateStatusReasonForm';

const BackdropBlur = styled(Backdrop)({
    backdropFilter: 'blur(6px)',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
});

const UpdateStatusButtonModal = ({
    id,
    onClose,
    onSuccess,
    currentStatus,
    newStatus,
    setNewStatus,
    statusOptions = [],
    lastModified,
}) => {
    const statusButton = useRef(null);
    const [openStatusMenu, setOpenStatusMenu] = useState(false);
    const isResolvingInvoice = currentStatus === 'InvoiceReview' && newStatus === 'Resolved';

    const handleOpenMenu = () => {
        setOpenStatusMenu(true);
    };
    const handleCloseMenu = () => {
        setOpenStatusMenu(false);
    };
    const handleSelectNewStatus = (state) => {
        setNewStatus(state);
        handleCloseMenu();
    };

    return (
        <Dialog
            open
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            slots={{ backdrop: BackdropBlur }}
            slotProps={{ paper: { sx: { borderRadius: '8px', padding: '48px 36px 24px' } } }}
        >
            <IconButton onClick={onClose} sx={{ position: 'absolute', top: 12, right: 12 }}>
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ padding: '0px' }}>
                <Box display="flex" justifyContent="flex-start" gap="50px" mb={2}>
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap="8px">
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '12px',
                                lineHeight: '100%',
                                letterSpacing: '0.07rem',
                                textTransform: 'uppercase',
                                color: COLORS.LT_MIDNIGHT500,
                            }}
                        >
                            FROM
                        </Typography>
                        <StatusPill status={currentStatus} sx={{ padding: 2 }} />
                    </Box>
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap="8px">
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '12px',
                                lineHeight: '100%',
                                letterSpacing: '0.07rem',
                                textTransform: 'uppercase',
                                color: COLORS.LT_MIDNIGHT500,
                            }}
                        >
                            TO
                        </Typography>
                        <StatusPill
                            status={newStatus}
                            content={
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    {PROCESSED_TIMESHEET_STATUS_LABELS[newStatus] ||
                                        'Select status'}
                                    <KeyboardArrowDownIcon
                                        sx={{
                                            ml: 'auto',
                                            transition: 'transform 0.3s',
                                            transform: openStatusMenu
                                                ? 'rotate(180deg)'
                                                : 'rotate(0deg)',
                                        }}
                                    />
                                </Box>
                            }
                            sx={{ padding: 2 }}
                            ref={statusButton}
                            onClick={handleOpenMenu}
                        />

                        <Menu
                            id="change-status-options"
                            open={openStatusMenu}
                            anchorEl={statusButton.current}
                            onClose={handleCloseMenu}
                        >
                            {statusOptions.map((state) => (
                                <MenuItem
                                    key={state}
                                    onClick={() => handleSelectNewStatus(state)}
                                    disableRipple
                                >
                                    <StatusPill status={state} sx={{ minWidth: 146 }} />
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Box>
                {isResolvingInvoice ? (
                    <InvoiceReviewResolutionForm id={id} onClose={onClose} onSuccess={onSuccess} />
                ) : (
                    <UpdateStatusReasonForm
                        onSuccess={onSuccess}
                        id={id}
                        lastModified={lastModified}
                        newStatus={newStatus}
                        onClose={onClose}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default UpdateStatusButtonModal;
